// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fTzA","colBig":"styles_colBig__3rVTK","colSmall":"styles_colSmall__2eItW","shopifyNameWrapper":"styles_shopifyNameWrapper__3Nnrt"};